import { render, staticRenderFns } from "./fengXianXinxi.vue?vue&type=template&id=6c8657fc&"
import script from "./fengXianXinxi.vue?vue&type=script&lang=js&"
export * from "./fengXianXinxi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports